import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="revora-footer">
      <div className="footer-content">
        {/* Left side: Logo & tagline */}
        <div className="footer-logo">
          <h2>Revora</h2>
          <p>Luxury Cars. Redefined.</p>
        </div>

        {/* Center: Navigation links */}
        <div className="footer-links">
          <a href="#brands">Brands</a>
          <a href="#configurator">Configurator</a>
          <a href="#booking">Booking</a>
          <a href="#about">About Us</a>
        </div>

        {/* Right side: Social media */}
        <div className="footer-socials">
          <a href="#"><i className="fab fa-instagram"></i></a>
          <a href="#"><i className="fab fa-twitter"></i></a>
          <a href="#"><i className="fab fa-facebook"></i></a>
          <a href="#"><i className="fab fa-youtube"></i></a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Revora. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
